import React, {useState, useEffect} from "react";
import {
  Container,Typography,
} from "@mui/material";
import FixedBottomNavigation from "../components/FixedBottomNavigation";
import PageHeader from "../components/PageHeader"; // 
import { supabase } from "../supabaseClient";

const Setting = () => {
  const [user, setUser] = useState(null); // ✅ 사용자 정보 상태 추가

  useEffect(() => {
    let isMounted = true; // ✅ 컴포넌트가 언마운트되었는지 체크

    // ✅ onAuthStateChange 구독 및 클린업 처리
    const { data: { subscription } } = supabase.auth.onAuthStateChange((_, session) => {
      if (isMounted){
        setUser(session?.user ?? null);
      }
    });

    return () => {
      isMounted = false; // ✅ 언마운트 시 API 호출 막기
      subscription?.unsubscribe(); // ✅ 구독 해제
    };
  }, []);

  return (
    <Container sx={{ pb: 8, pt: 6 }}>
      {/* 🔹 헤더 영역 */}
      <PageHeader title="Setting" />

      {user ? (
        <>
        <Typography variant="subtitle1" fontWeight="bold">알람설정</Typography>
        </>
      ) : (
        <Typography sx={{ mt: 4 }}>사용자 정보를 불러오는 중...</Typography>
      )}
      <FixedBottomNavigation />
    </Container>
  );
};

export default Setting;
